<template>
    <div class="l-goal-feed-item" style="display: flex">
        <span class="hidden-xs" style="flex: 0 0 10%;">
            <l-profile-picture :user="feedItem.user" size="m" />
        </span>

        <span style="flex: 0 0 70%;">
            <span class="hidden-xs">
                <span class="skill-title color-primary">
                    <span
                        class="fake-link clickable"
                        tabindex="0"
                        @click="goToGoalDetails()"
                        @keyup.enter="goToGoalDetails()"
                    >
                        <span v-if="feedItem.type === 'update'">
                            <l-text
                                :text="
                                    $t(`goals.list.feedGoalUpdate`, {
                                        name: feedItem.user.fullname,
                                        goalTitle: feedItem.goal.name,
                                    })
                                "
                            />
                        </span>
                        <span v-else-if="feedItem.type === 'comment'">
                            <l-text
                                :text="
                                    $t(`goals.list.feedGoalComment`, {
                                        name: feedItem.user.fullname,
                                        goalTitle: feedItem.goal.name,
                                    })
                                "
                            />
                        </span>
                    </span>
                </span>
                <div class="hr-small"></div>
                <div v-html="feedItem.content" />
            </span>
        </span>

        <span class="hidden-xs" style="flex: 0 0 20%;">
            <span class="color-grey pull-right">
                {{ feedItem.date }}
                <span class="color-grey l-default-margin-s">
                    <i
                        :class="{
                            'fal fa-pencil': feedItem.type === 'update',
                            'fal fa-comment': feedItem.type === 'comment',
                        }"
                    ></i>
                </span>
            </span>
        </span>
    </div>
</template>

<script>
import LProfilePicture from "@/components/LProfilePicture";
import LText from "@/components/LText";

export default {
    components: {
        LProfilePicture,
        LText,
    },
    props: {
        feedItem: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {
        goToGoalDetails() {
            this.$router.push(`/goals/details/${this.feedItem.goal._id}`);
        },
    },
};
</script>

<style scoped></style>
